var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.length)?_c('div',{staticClass:"chart-wrapper"},[_c('div',{staticClass:"delivery"},[_vm._v(" Delivery Bandwidth ")]),_c('div',{ref:"chart",staticClass:"chart"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }